import { Appearance } from '@stripe/stripe-js';

/**
 * Makes `PaymentElement` look like the fields around it.
 *
 * The rest of the form is underlined inputs on the page background, not boxed
 * ones — mirrored here so the payment section reads as part of the form rather
 * than an embedded widget. Values match `_colors`/`_typography`; they have to
 * be literals because Stripe renders inside an iframe that our stylesheet
 * cannot reach.
 */
export const PAYMENT_APPEARANCE: Appearance = {
  variables: {
    fontFamily: '"Red Hat Text Normal", Helvetica, sans-serif',
    fontSizeBase: '15px',
    colorText: '#121212',
    colorTextPlaceholder: '#c4c4c4',
    colorDanger: '#b00020',
    borderRadius: '0px',
    spacingUnit: '4px'
  },
  rules: {
    '.Input': {
      border: 'none',
      borderBottom: '1px solid #959595',
      boxShadow: 'none',
      padding: '16px 0 12px'
    },
    '.Input:focus': {
      border: 'none',
      borderBottom: '1px solid #121212',
      boxShadow: 'none',
      outline: 'none'
    },
    '.Input--invalid': {
      borderBottom: '1px solid #b00020',
      boxShadow: 'none'
    },
    '.Label': {
      fontSize: '12px',
      letterSpacing: '0.05em',
      textTransform: 'uppercase'
    },
    '.Tab': {
      border: '1px solid #eaeaea',
      boxShadow: 'none'
    },
    '.Tab--selected': {
      border: '1px solid #121212',
      boxShadow: 'none'
    }
  }
};
